import { visit } from "unist-util-visit";

type HastNode = any;

export default function rehypeBrBreak() {
    return (tree: HastNode) => {
        visit(tree, "text", (node: HastNode, index: number | null | undefined, parent: HastNode | null | undefined) => {
            if (!parent || typeof index !== "number") return;

            const value = typeof node.value === "string" ? node.value : "";
            if (!value || !value.includes("::br")) return;

            const segments = value.split("::br");
            const newChildren: HastNode[] = [];

            segments.forEach((segment: string, segmentIndex: number) => {
                if (segment) {
                    newChildren.push({ type: "text", value: segment });
                }

                if (segmentIndex < segments.length - 1) {
                    newChildren.push({ type: "element", tagName: "br", properties: {}, children: [] });
                }
            });

            parent.children.splice(index, 1, ...newChildren);
            return index + newChildren.length;
        });
    };
}
